module.exports = __webpack_public_path__ + "img/11.53b6fe06.jpg";